
import { GlassCard } from "@/components/ui/glass-card";
import { Button } from "@/components/ui/button";
import { Terminal, ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import StatusBadge from "@/components/StatusBadge";

interface Deployment {
  id: string;
  status: string;
  last_run: string | null;
  configurations?: {
    name: string;
  };
}

interface DeploymentHistoryProps {
  deployments?: Deployment[];
}

const DeploymentHistory = ({ deployments }: DeploymentHistoryProps) => {
  return (
    <GlassCard variant="default" hover={false} className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-xl font-semibold text-slate-900 dark:text-white">Recent Deployments</h2>
        <Link to="/configurations">
          <Button variant="outline" className="flex items-center gap-2">
            View Configurations
            <ChevronRight className="h-4 w-4" />
          </Button>
        </Link>
      </div>
      <div className="space-y-4">
        {deployments?.map((deployment) => (
          <div key={deployment.id} className="flex items-center justify-between p-4 bg-slate-50 dark:bg-slate-900 rounded-lg">
            <div className="flex items-center gap-3">
              <Terminal className="h-5 w-5 text-blue-600" />
              <div>
                <p className="font-medium text-slate-900 dark:text-white">
                  {deployment.configurations?.name || 'Unnamed Script'}
                </p>
                <p className="text-sm text-slate-500">
                  Last run: {deployment.last_run ? new Date(deployment.last_run).toLocaleString() : 'Never'}
                </p>
              </div>
            </div>
            <StatusBadge status={deployment.status} />
          </div>
        ))}
        {(!deployments || deployments.length === 0) && (
          <p className="text-center text-slate-500">No deployments found</p>
        )}
      </div>
    </GlassCard>
  );
};

export default DeploymentHistory;
